import { useEffect, useState } from "react";

const useScript = (url: string, deferred?: boolean, scriptId?: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [state, setState] = useState({
    loaded: false,
    error: false
  });

  useEffect(() => {
    const script = document.createElement("script");

    const onScriptLoad = () => {
      setState({
        loaded: true,
        error: false
      });
    };

    const onScriptError = () => {
      script.remove();

      setState({
        loaded: true,
        error: true
      });
    };

    script.src = url;
    if (deferred) {
      script.defer = true;
    } else {
      script.async = true;
    }
    if (scriptId) {
      script.id = scriptId;
    }

    script.addEventListener("load", onScriptLoad);
    script.addEventListener("error", onScriptError);

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url, deferred, scriptId]);
};

export default useScript;
